import { FCWithChildren } from 'common/types';
import Text from 'components/_core/Text';

import { Wrapper } from './styles';

const HelpSection: FCWithChildren = ({ children }) => (
  <Wrapper>
    <Text size="sm">{children}</Text>
  </Wrapper>
);

export default HelpSection;
